import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcMaintenanceTypeModule } from '@core/components/fc-input/search-one/fc-maintenance-type-input/fc-maintenance-type-input.module';
import { FcPaginatorModule } from '@core/components/fc-paginator/fc-paginator.module';
import { FormsComponentModule } from '@core/components/inputs/forms/forms.module';
import { MaintenanceTypeSearchComponentModule } from '@core/components/inputs/maintenance-type-search/maintenance-type-search.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogSegmentsComponent } from './dialog-segments.component';
import { TabFormsComponent } from './tabs/forms/tab-forms.component';
import { TabGeneralComponent } from './tabs/general/tab-general.component';
import { LinkGroupsComponent } from './tabs/groups/link-groups/link-groups.component';
import { TabGroupsComponent } from './tabs/groups/tab-groups.component';
import { TabSettingsComponent } from './tabs/settings/tab-settings.component';


@NgModule({
  entryComponents: [
    DialogSegmentsComponent,
    LinkGroupsComponent
  ],
  declarations: [
    DialogSegmentsComponent,
    LinkGroupsComponent,
    TabGeneralComponent,
    TabGroupsComponent,
    TabFormsComponent,
    TabSettingsComponent
  ],
  exports: [
    DialogSegmentsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,

    FuseSharedModule,
    FuseSidebarModule,

    MatTooltipModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatTabsModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDialogModule,

    FcPaginatorModule,
    DisclaimerModule,
    FormsComponentModule,
    MaintenanceTypeModule,
    FcMaintenanceTypeModule,
    FcMaintenanceTypesInputModule,
    MaintenanceTypeSearchComponentModule
  ],
  providers: [
    CustomMessagesService
  ]
})
export class DialogSegmentsModule {}
